<template>
  <BaseAutoCompleteWithSingleSelectedItem
    v-model="modelValue"
    label="ドライバー"
    itemName="name"
    :items="filteredByDepartment"
    :initial-item-id="initialItemId"
    :management-office="managementOffice"
    :operation-offices="operationOffices"
    :error-messages="errorMessages"
    :disabled="disabled"
  />
</template>
<script setup lang="ts">
import BaseAutoCompleteWithSingleSelectedItem from '@/components/AutoCompletes/BaseAutoCompleteWithSingleSelectedItem.vue';
import { DRIVER_ROLE_ID } from "@/services/consts/account";
import { OPERATION_OFFICE_TYPE } from "@/services/consts";
import getManagementOffice from '@/types/responses/getManagementOffice';
import getOperationOffice from '@/types/responses/getOperationOffice';
import getAccountResponse from '@/types/responses/getAccount';
import getDepartmentResponse from '@/types/responses/getDepartment';
import getAccountsType from "@/types/requests/getAccounts";
import { onMounted, ref, computed } from 'vue';
import Api from '@/services/api/ApiServiceFabrick';

const props = defineProps<{
  modelValue: getAccountResponse | undefined;
  selectedDepartment: getDepartmentResponse | null
  initialItemId?: number;
  managementOffice?: getManagementOffice;
  operationOffices?: getOperationOffice[];
  errorMessages?: string[];
  disabled?: boolean;
}>();

const emit = defineEmits<{
  (e: 'update:modelValue', text: getAccountResponse | undefined): void,
  (e: 'isDriverLoading', isloading: boolean): void
}>();

const items = ref<getAccountResponse[]>([]);
const isLoading = ref<boolean>(true);

onMounted(() => {
  const params: getAccountsType = {
    officeable_type: OPERATION_OFFICE_TYPE,
    role_id: DRIVER_ROLE_ID
  }
  if(props.operationOffices && props.operationOffices.length > 0) {
    params.type_class = OPERATION_OFFICE_TYPE,
    params.officeable_id = props.operationOffices[0].id
  }
  Api()
    .autoCompleteAccounts(params)
    .then((data) => {
      items.value = data;
      isLoading.value = false
      emit("isDriverLoading", false);
    });
});

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  },
});

const filteredByDepartment = computed(() => {
  if (!props.selectedDepartment) return items.value
  return items.value.filter(item => item.department_id === props.selectedDepartment?.id)
})
</script>
